import { render, staticRenderFns } from "./SystemRequirementInput.vue?vue&type=template&id=34dc2af8&scoped=true&"
import script from "./SystemRequirementInput.vue?vue&type=script&lang=ts&"
export * from "./SystemRequirementInput.vue?vue&type=script&lang=ts&"
import style0 from "./SystemRequirementInput.vue?vue&type=style&index=0&id=34dc2af8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dc2af8",
  null
  
)

export default component.exports